import React from "react";
import { Box, Typography, Divider } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
// import SendIcon from "@mui/icons-material/Send";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
// import last from "../images/last.png";
import logo from "../images/logo.png";
import { Link, scroller } from "react-scroll";
import { useNavigation } from "../Context/NavigationContext";
import { useLocation, useNavigate } from "react-router-dom/dist";

// Reusable Social Icons
const IconGroup = () => (
  <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
    <FacebookIcon sx={{ cursor: "pointer", "&:hover": { color: "blue" } }} />
    <TwitterIcon sx={{ cursor: "pointer", "&:hover": { color: "#1DA1F2" } }} />
    <LinkedInIcon sx={{ cursor: "pointer", "&:hover": { color: "#0077b5" } }} />
    <InstagramIcon
      sx={{ cursor: "pointer", "&:hover": { color: "#e1306c" } }}
    />
  </Box>
);
export default function About() {
  const { setScrollTarget } = useNavigation();
  const navigate = useNavigate();
  const handleNavigateToSection = (path) => {
    console.log("pathname", path);
    if (window.location.pathname === "/") {
      scroller.scrollTo(path, {
        duration: 800,
        delay: 0,
        smooth: "easeInOutQuart",
        offset: -80,
      });
    } else {
      setScrollTarget(path); // Store the target in context
      navigate("/");
    }
  };

  const handleServiceClick = (id) => {
    navigate("/service#service-" + id);
  };

  const currentYear = new Date().getFullYear();
  return (
    <>
      <Box
        sx={{
          scrollMarginTop: "100px",
          px: { xs: 2, sm: 4, md: 6 },
          py: 5,
          mt: { xs: 8, md: 10 }, // Less negative margin on small screens
          position: "relative",
          background: "#0c111d",
          overflowX: "hidden",
        }}
      >
        {/* Contact Boxes */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            width: { xs: "100%", md: "70%" },
            mx: "auto",
            // mt: { xs: 5, md: 20 },
            gap: { xs: 1, md: 2 },
            py: 5,
            justifyContent: "center",
          }}
        >
          {/* Email */}
          <ContactBox
            icon={<EmailIcon sx={{ fontSize: 40 }} />}
            bgColor="#a10304"
            title="Write to us"
            value=" info@censoftech.com"
          />
          {/* Phone */}
          <ContactBox
            icon={<PhoneIcon sx={{ fontSize: 40 }} />}
            bgColor="#032262"
            title="Call Us"
            value=" +(603) 83193122"
          />
          {/* Location */}
        </Box>
{/* 
        <Divider
          sx={{
            height: "1px",
            backgroundColor: "gray",
            mb: 2,
            width: { xs: "90%", md: "70%" },
            mx: "auto",
          }}
        /> */}

        {/* Footer Info */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-between",
            py: 6,
            color: "white",
            gap: { xs: 4, md: 5 },
            width: { xs: "95%", sm: "90%", md: "80%" },
            mx: "auto",
          }}
        >
          <Link
            to="home" // This should match the ID of your target element
            smooth={true}
            duration={500}
            offset={-80}
            onClick={() => handleNavigateToSection("home")} // Move onClick here
          >
            <Box
              component="img"
              src={logo}
              alt="Company Logo"
              sx={{
                width: { xs: 200, md: 400 }, // Responsive width
                boxShadow: 2,
                objectFit: "contain", // Changed from "cover" to "contain" for logos
                zIndex: 1,
                backgroundColor: "#fff",
                cursor: "pointer",
                "&:hover": {
                  opacity: 0.9,
                },
              }}
            />
          </Link>

          {/* Company */}
          <FooterColumn
            title="Company"
            items={[
              { name: "About Us", path: "about" },
              { name: "Why Censoft", path: "workflow" },
              { name: "Industries", path: "industries" },
              { name: "Services", path: "services" }, // General services page
              { name: "Products", path: "products" },
              { name: "Contact Us", path: "locations" },
            ]}
          />
          {/* Services */}
          <FooterColumn
            title="Our Services"
            items={[
              { name: "Application Services", id: "1" },
              { name: "Managed Services", id: "2" },
              { name: "AI & Data Science", id: "3" },
              { name: "Business Consulting", id: "4" },
              { name: "Cloud Solutions", id: "5" },
              { name: "Cybersecurity Solutions", id: "6" },
            ]}

          />
          {/* Industries */}
          <FooterColumn
            title="Our Industries"
            items={[
              { name: "Oil & Gas", path: "industries" },
              { name: "Manufacturing", path: "industries" },
              { name: "Construction", path: "industries" },
              { name: "Insurance", path: "industries" },
              { name: "Education", path: "industries" },
              { name: "Banking", path: "industries" },
              { name: "Healthcare", path: "industries" },
              { name: "Automative", path: "industries" },
            ]}
            path="industries"
          />
        </Box>

        {/* Social Media Footer */}
        <Divider
          sx={{ backgroundColor: "gray", width: "80%", mx: "auto", mb: 3 }}
        />
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            color: "white",
          }}
        >
          <Typography variant="body2" fontSize={13} color="white">
            &copy; {currentYear} Censoft. All rights reserved.
          </Typography>
         
        </Box>
      </Box>
    </>
  );
}

const ContactBox = ({ icon, bgColor, title, value }) => (
  <Box
    sx={{
      flex: { xs: "1 1 100%", md: 0.5 }, // full width on mobile, half on md+
      border: "1px solid gray",
      borderRadius: 2,
      color: "white",
      p: { xs: 1, sm: 3 },
      display: "flex",
      alignItems: "center",
      gap: { xs: 3, md: 3 },
      minWidth: { xs: "auto", md: 280 }, // min width on desktop
    }}
  >
    <Box
      sx={{
        background: bgColor,
        width: { xs: 50, sm: 60, md: 70 },
        height: { xs: 50, sm: 60, md: 70 },
        borderRadius: 10,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexShrink: 0,
        border: "2px solid #fff",
      }}
    >
      {icon}
    </Box>
    <Box>
      <Typography
        variant="subtitle1"
        fontWeight="bold"
        fontSize={{ xs: 16, md: 18 }}
      >
        {title}
      </Typography>
      <Typography
        variant="h6"
        fontWeight="bold"
        sx={{ mt: 0.5 }}
        fontSize={{ xs: 18, md: 20 }}
      >
        {value}
      </Typography>
    </Box>
  </Box>
);
const FooterColumn = ({ title, items }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigateToSection = (path) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        scroller.scrollTo(path, {
          duration: 500,
          smooth: true,
          offset: -80
        });
      }, 100);
    } else {
      scroller.scrollTo(path, {
        duration: 500,
        smooth: true,
        offset: -80
      });
    }
  };

   const handleServiceClick = (id) => {
    navigate("/service#service-" + id);
  };


  return (
    <Box
      sx={{
        flex: { xs: "1 1 100%", md: 1 },
        minWidth: { xs: "auto", md: 200 },
        mb: { xs: 4, md: 0 },
      }}
    >
      <Typography 
        variant="h6" 
        fontWeight="bold" 
        color="gray" 
        gutterBottom 
        fontSize={{ xs: 18, md: 20 }}
      >
        {title}
      </Typography>
      {items?.map((item) => (
        <Link
          key={item.path}
          to={item.path}
          smooth={true}
          duration={500}
          offset={-80}
          spy={true}
          activeClass="active"
          onClick={["1","2","3","4","5","6"].includes(item.id) ? ()=> handleServiceClick(item.id) : () => handleNavigateToSection(item.path)}
          style={{
            display: 'block',
            textDecoration: 'none',
            color: 'inherit',
            marginTop: '8px'
          }}
        >
          <Typography
            fontSize={{ xs: 14, md: 15 }}
            fontWeight="bold"
            sx={{ 
              cursor: "pointer", 
              "&:hover": { color: "orange" } 
            }}
          >
            {item.name}
          </Typography>
        </Link>
      ))}
    </Box>
  );
};
